import React from 'react'
import {Menu, MenuItem} from '@mui/material';
import {withStyles} from 'tss-react/mui';
import {ProfileButton} from "./ProfileButton";

interface ProfileMenuItem {
    label: string;
    onClick: () => void;
}

interface ProfileMenuProps {
    menuItems: ProfileMenuItem[];
    profileLabel: string;
}

export const ProfileMenu = ({
                                menuItems,
                                profileLabel,
                            }: ProfileMenuProps) => {
    const id = `menu-profile`;
    const StyleMenuItem = withStyles(MenuItem, {root: {fontFamily: "inherit"}});
    const [anchorElement, setAnchorElement] = React.useState<HTMLElement | null>(null);

    const open = Boolean(anchorElement);

    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElement(event.currentTarget);
    };

    const handleMenuItemClick = (onClick: () => void) => {
        onClick();
        handleClose();
    };

    const handleClose = () => {
        setAnchorElement(null);
    };

    return (
        <div className={`clearfix`}>
            <ProfileButton
                aria_controls={id}
                label={profileLabel}
                name={`btnProfile`}
                onClick={handleMenu}
            />
            <br className={`clearfix`}/>
            <Menu
                id={id}
                anchorEl={anchorElement}
                keepMounted
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                open={open}
                onClose={handleClose}
            >
                {
                    menuItems.map((item: ProfileMenuItem, key: number) => {
                        return (
                            <StyleMenuItem key={key} onClick={() => handleMenuItemClick(item.onClick)}>
                                {item.label}
                            </StyleMenuItem>
                        );
                    })
                }

            </Menu>
        </div>
    );
}
